module.exports = __webpack_public_path__ + "img/sand-rock-medium-14.a683adfd.png";